var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('router-link',{staticClass:"hover-item",class:{ active: _vm.isActive },attrs:{"to":_vm.to}},[_vm._t("name"),_vm._v(" "),_c('span',{staticClass:"icon"},[_vm._t("icon")],2)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27b65def","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/menubar-link.vue
// module id = null
// module chunks = 